/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Syllabus upload container with internationalization wrapper.
 *
 * @file SyllabusUploadContainer.jsx
 * @author Satyaki Bose
 * @since 2.0.0
 */

import React from 'react';
import PropTypes from 'prop-types';
import { IntlProvider } from 'react-intl';
import { InternationalSupport } from '@aquila/core';
import ContainerShell from './ContainerShell';
import ErrorBoundary from '../components/common/ErrorBoundary';
import msgObject from '../../translations';

const SyllabusUploadContainer = ({ locale, children }) => {
  const intlObj = new InternationalSupport(msgObject, locale);

  return (
    <ContainerShell>
      <IntlProvider locale={intlObj.getLocale()} messages={intlObj.getMessages()}>
        <ErrorBoundary>
          {children}
        </ErrorBoundary>
      </IntlProvider>
    </ContainerShell>
  );
};

SyllabusUploadContainer.propTypes = {
  locale: PropTypes.string,
  children: PropTypes.node
};

SyllabusUploadContainer.defaultProps = {
  locale: 'en',
  children: null
};

export default SyllabusUploadContainer;
